import { render, staticRenderFns } from "./WeatherStationCentral.vue?vue&type=template&id=64e6c2cb&"
import script from "./WeatherStationCentral.vue?vue&type=script&lang=js&"
export * from "./WeatherStationCentral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports